import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { ReviewStatus, } from '../../../../features/entities/reviews-entities';
import { ReviewFormSteps } from '../../../../features/entities/rfp-status-flow-entities';
import { useTranslations } from '../../../../features/providers/translations-provider';
import ReviewFlowLayout from '../../common/review-flow-layout';
import ReviewFormHeader from './header';
import ReviewConfirm from './review-confirm';
import ReviewContact from './review-contact';
import ReviewExperience from './review-experience';
const ReviewForm = ({ providerName, providerId, rfpId, handleClose, reviewProvider, reviewStep, setReviewStep, tags, companyTags, }) => {
    var _a, _b;
    const { t } = useTranslations();
    const ref = useRef(null);
    const [forms, setForms] = useState({
        experienceForm: undefined,
        contactForm: undefined,
    });
    const [submitLoading, setSubmitLoading] = useState(false);
    const isFromWebsite = useMemo(() => !rfpId, [rfpId]);
    const handleSubmit = async () => {
        var _a, _b;
        try {
            setSubmitLoading(true);
            const [experienceFormValues, contactFromValues] = await Promise.all([
                (_a = forms.experienceForm) === null || _a === void 0 ? void 0 : _a.validateFields(),
                (_b = forms.contactForm) === null || _b === void 0 ? void 0 : _b.validateFields(),
            ]);
            const review = {
                review_id: '',
                provider_id: providerId,
                rfp_id: rfpId,
                description_summary: experienceFormValues === null || experienceFormValues === void 0 ? void 0 : experienceFormValues.summary,
                rating_collaboration: experienceFormValues === null || experienceFormValues === void 0 ? void 0 : experienceFormValues.relationship,
                rating_quality: experienceFormValues === null || experienceFormValues === void 0 ? void 0 : experienceFormValues.quality,
                recommend: experienceFormValues === null || experienceFormValues === void 0 ? void 0 : experienceFormValues.recommend,
                status: ReviewStatus.Public,
                locale: 'fr',
                service: experienceFormValues === null || experienceFormValues === void 0 ? void 0 : experienceFormValues.service,
                verified: 'Unverified',
                review_source: 'Client App',
            };
            const reviewRequest = {
                review: review,
                contact_name: contactFromValues === null || contactFromValues === void 0 ? void 0 : contactFromValues.contact_name,
                contact_email: contactFromValues === null || contactFromValues === void 0 ? void 0 : contactFromValues.contact_email,
                contact_title: contactFromValues === null || contactFromValues === void 0 ? void 0 : contactFromValues.contact_title,
                company_name: contactFromValues === null || contactFromValues === void 0 ? void 0 : contactFromValues.company_name,
                company_industry: contactFromValues === null || contactFromValues === void 0 ? void 0 : contactFromValues.company_industry,
                company_size: contactFromValues === null || contactFromValues === void 0 ? void 0 : contactFromValues.company_size,
                terms: 'Agree',
            };
            await reviewProvider(reviewRequest);
            setReviewStep(ReviewFormSteps.Confirm);
            setSubmitLoading(false);
        }
        catch (e) {
            console.error(e);
            setSubmitLoading(false);
        }
    };
    return reviewStep === ReviewFormSteps.Confirm ? (_jsx(ReviewConfirm, { handleClose: handleClose, isActive: true })) : (_jsx(ReviewFlowLayout, { title: _jsx(_Fragment, { children: t('reviews|newReviewRatingHeading', { providerName }) }), description: reviewStep === ReviewFormSteps.Contact
            ? t('reviews|newReviewRatingSubheadingContact')
            : t('reviews|newReviewRatingSubheading'), children: _jsxs("div", { ref: ref, children: [_jsx(ReviewFormHeader, { rfpId: rfpId, reviewStep: reviewStep }), _jsx(ReviewExperience, { providerName: providerName, experiences: (_a = forms === null || forms === void 0 ? void 0 : forms.experienceForm) === null || _a === void 0 ? void 0 : _a.getFieldsValue(true), setForms: setForms, setFlowStep: setReviewStep, isActive: reviewStep == ReviewFormSteps.Experience, tags: tags, isFromWebsite: isFromWebsite, handleSubmit: handleSubmit, submitLoading: submitLoading }), isFromWebsite && (_jsx(ReviewContact, { contactInfo: (_b = forms === null || forms === void 0 ? void 0 : forms.contactForm) === null || _b === void 0 ? void 0 : _b.getFieldsValue(true), setForms: setForms, setFlowStep: setReviewStep, isActive: reviewStep == ReviewFormSteps.Contact, handleSubmit: handleSubmit, isSubmit: true, companyTags: companyTags, submitLoading: submitLoading }))] }) }));
};
export default ReviewForm;
